import React from "react";
import {
	CustomIconButton,
	GenericDialog,
	GenericDialogHeader,
	GenericDialogContent,
	icon,
} from "../../../../common/components";
import { translate } from "../../../../common/providers";
import styles from "./DeliverableSidePanel.module.css";

export default function TemplateDialog({ open, templateHeaders, onClose }) {
	return (
		<GenericDialog maxWidth="md" open={open} onClose={onClose}>
			<GenericDialogHeader>
				<div className={styles.dialogHeader}>
					<CustomIconButton btnClassName={styles.closeButton} icon={icon.faTimes} onClick={onClose} />
					{translate("deliverables-list.import_template_format")}
				</div>
			</GenericDialogHeader>
			<GenericDialogContent>
				<div className={styles.dialogContent}>
					<table className={styles.table}>
						<thead>
							<tr>
								{templateHeaders &&
									templateHeaders.map((header) => (
										<th key={header} className={styles.tableHeader}>
											{header}
										</th>
									))}
							</tr>
						</thead>
						<tbody>
							<tr>
								{templateHeaders &&
									templateHeaders.map((header) => (
										<td key={header} className={styles.tableCell}>
											<span className={styles.placeholderText}>...</span>
										</td>
									))}
							</tr>
						</tbody>
					</table>
				</div>
			</GenericDialogContent>
		</GenericDialog>
	);
}
